"use client";

import GTMEventLink, { type GTMEventLinkProps } from "~/components/ui/GTMEventLink";
import { useQuizLink } from "~/components/features/quiz";

const FooterMenuLink = ({ href, ...props }: GTMEventLinkProps) => {
    const { href: resolvedHref } = useQuizLink(href);

    return <GTMEventLink {...props} href={resolvedHref} />;
};

export default FooterMenuLink;
